import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, currentUserProfile, authLoading } = useAuth();

  if (authLoading || user === undefined) return <p>Laddar...</p>;

  if (!user) return <Navigate to="/login" replace />;

  if (!currentUserProfile || currentUserProfile.active === false) {
    return <p>Du har inte behörighet att använda den här sidan.</p>;
  }

  if (allowedRoles && !allowedRoles.includes(currentUserProfile.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;